export const baseTab = {
  id: 1,
  color: "primary",
  label: "base",
  tabName: "Grund",
};

export const contrastTab = {
  id: 2,
  color: "primary",
  label: "contrast",
  tabName: "Kontrast",
};

export const stitchingTab = {
  id: 3,
  color: "primary",
  label: "stitching",
  tabName: "Nähte",
};

export const patchTab = {
  id: 4,
  color: "primary",
  label: "patch",
  tabName: "Knieverstärkung",
};
